<!-- Titre -->
<div class="page-title">
	{{ 'sites.site_list_page_title' | translate }}
</div>

<p-toolbar styleClass="pb-0">
	<ng-template pTemplate="left">
		<!-- Recherche -->
		<div class="grid formgrid fluid w-full">
			<div class="field col-fixed">
				<div class="p-inputgroup mr-2">
					<input
						pInputText
						type="text"
						[(ngModel)]="params.search"
						(onDebounce)="refresh()"
						placeholder="{{'common.search_input_placeholder' | translate}}"
					/>
					<button type="button" class="p-inputgroup-addon" icon="pi pi-times" pButton label="" [disabled]="!params.search || !loading" (click)="resetSearch()"></button>
				</div>
			</div>

			<!-- Coche Actif/Inactif -->
			<div class="col-fixed field field-checkbox">
				<p-checkbox
					name="sit_actif"
					inputId="sit_actif"
					[(ngModel)]="params.sit_actif"
					[binary]="true"
					[label]="'sites.inactive_state_plural' | translate"
					[trueValue]="false"
					[falseValue]="true"
					(ngModelChange)="refresh()"
				></p-checkbox>
			</div>
		</div>
	</ng-template>

	<ng-template pTemplate="right">
		<div class="grid formgrid fluid w-full">
			<div class="field col-fixed">
				<button
					type="button"
					pButton
					icon="pi pi-bars"
					[label]="'common.actions_button_label' | translate"
					class="p-panel-header-icon p-link"
					(click)="menu_list_sites.toggle($event)"
					*ngIf="menuItems.length"
				></button>
				<p-menu #menu_list_sites [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
			</div>
		</div>
	</ng-template>
</p-toolbar>
<p-table
	#tableSites
	[value]="values"
	[lazy]="true"
	(onLazyLoad)="loadSites($event)"
	[loading]="loading"
	[paginator]="true"
	[rows]="rows"
	[showCurrentPageReport]="true"
	[totalRecords]="totalRecords"
	currentPageReportTemplate="{{totalRecords | number}} {{'common.table_total_records'|translate}}"
	[rowsPerPageOptions]="[10,25,50]"
	styleClass="p-datatable-sm p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	scrollDirection="both"
	[scrollable]="true"
	scrollHeight="flex"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th class="text-center" pSortableColumn="sit_libelle">
				{{ 'sites.site_name_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.country_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.city_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.postal_code_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.email_label' | translate }}
			</th>
			<th class="text-center">
				{{ 'common.phone_label' | translate }}
			</th>

			<th></th>
		</tr>
	</ng-template>

	<!-- Message table vide -->
	<ng-template pTemplate="emptymessage">
		<tr>
			<td class="text-center" colspan="100">
				{{ 'common.no_table_results' | translate }}
			</td>
		</tr>
	</ng-template>


	<ng-template pTemplate="body" let-site>
		<tr [ngClass]="{'inactive': !site.sit_actif}">
			<td>{{site.sit_libelle}}</td>
			<td>{{site.sit_pays}}</td>
			<td>{{site.sit_ville}}</td>
			<td>{{site.sit_code_postal}}</td>
			<td>{{site.sit_email}}</td>
			<td>{{site.sit_telephone}}</td>

			<td class="nowrap" *ngIf="!readonly">
				<a
					pButton
					icon="pi pi-eye"
					class="p-button-rounded p-button-text"
					uiSref=".single"
					[uiParams]="{sit_id: site.sit_id}"
				></a>
				<button
					type="button"
					pButton
					icon="pi pi-trash"
					class="p-button-rounded p-button-text p-button-danger"
					(click)="deleteSite(site)"
					*ngIf="canEdit"
				></button>
			</td>
		</tr>
	</ng-template>

</p-table>

